import Cookies from 'js-cookie';

export function setSid(sid) {
  Cookies.set('sid', sid);
}

export function getSid() {
  return Cookies.get('sid');
}

export function setMarkId(markid) {
    Cookies.set('markid', markid);
}

export function getMarkId() {
    return Cookies.get('markid');
}


// WEBPACK FOOTER //
// ./src/utils/SidManager.js